import { Layout } from "providers/Layout";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { LockboxAccountsList } from "views/settings-integration/integrations/shared/LockboxAccountsList";
import { LockboxCredentialsTab } from "views/settings-integration/integrations/shared/LockboxCredentialsTab";

export const SentriLockView = () => (
  <Layout
    header={
      <IntegrationDetailHeader
        id={IntegrationId.SENTRILOCK}
        name="SentriLock"
        path="/settings/integration/sentrilock"
      />
    }
  >
    <LockboxCredentialsTab />
    <LockboxAccountsList vendor="sentrilock" />
  </Layout>
);
